import api from '../utilPartner';
import utilsAxios from '../../utils/axiosUtils'

const controller = 'ImportacaoPessoa';
const urlPessoa = process.env.VUE_APP_PERSON_API + controller;
const urlPartner = process.env.VUE_APP_ROOT_API + controller;

export default {
  controller,
  Localizar: codigo => {
    return api.Axios.GetParams(`${urlPessoa}/${codigo}`);
  },
  Listar: dto => {
    const params = new URLSearchParams();

    if (dto.situacoesList) {
      dto.situacoesList.forEach(val => params.append('situacoesList', val));
    }

    const formatedParams = utilsAxios.FormatarParametrosComArray(dto, params);
    return api.Axios.GetParams(urlPessoa + '?' + formatedParams.toString());
  },
  ImportacaoPessoaResumo: dto => {
    return api.Axios.GetParams(`${urlPessoa}/ImportacaoPessoaResumo`, dto);
  },
  Importar: dto => {
    return api.Axios.PostForm(`${urlPessoa}/Importar`, dto);
  },
  ResumoArquivo: dto => {
    return api.Axios.PostForm(`${urlPessoa}/Arquivo/Resumo`, dto);
  },
  Reprocessar: (dto, codigo) => {
    return api.Axios.Put(urlPessoa, codigo, dto);
  },
  Criar: (dto) => {
    return api.Axios.Post(urlPessoa, dto);
  },
  CriarSync: (dto) => {
    return api.Axios.Post(`${urlPessoa}/Sync`, dto);
  },
  Deletar: codigo => {
    return api.Axios.Delete(urlPessoa, codigo);
  },
  DeletarTodos: () => {
    return api.Axios.Delete(`${urlPessoa}/Todos`, '');
  },
  Download: (filename) => {
    const url = process.env.VUE_APP_PERSON_API + 'Static/' + filename;

    return api.Axios.DownloadFile(url);
  },
  ListarHistoricoPorCliente: dto => {
    return api.Axios.GetParams(urlPartner + '/ListarHistoricoPorCliente', dto);
  },
  ListarHistorico: dto => {
    return api.Axios.GetParams(urlPartner + '/ListarHistorico', dto);
  },
};

